/**
 * Localized<T> + L() (I18N_PLAN.md Phase 4, Architecture decision 9).
 *
 * The structured `src/data/*.ts` files (portfolio exemplars, career-transition
 * frameworks, curriculum content, interview scenarios, etc.) hold far more
 * English prose than component JSX does, but a full translation pass is out
 * of scope for now (I18N_PLAN.md's explicit non-goals). Wrapping each
 * top-level exported constant in `Localized<T>` is the one schema change
 * that unblocks translating that content later WITHOUT another refactor:
 * Phase 5 (or beyond) adds a sibling `es: {...}` with the same shape: no
 * consumer changes needed. Content stays English-only until then — `L()`
 * always resolves to `.en` today since no data file has an `es` key yet.
 */

export type Localized<T> = { en: T; es?: T };

/** Resolve a Localized<T> constant for the given locale, falling back to
 *  English for any locale without a translation (including region variants
 *  like "es-MX" → "es", and the dev-only pseudo-locale, which never applies
 *  to structured data — only to react-i18next string resources). */
export function L<T>(value: Localized<T>, locale: string): T {
  const base = locale.split("-")[0];
  if (base === "es" && value.es !== undefined) {
    return value.es;
  }
  return value.en;
}
